<template>
  <a-modal
    v-if="problem"
    title=""
    v-model="modalVisible"
    :footer="null"
    :width="980"
    :destroyOnClose="true"
    centered
  >
    <OperationCard
    :initialOffice="initialOffice"
      :selectedPOffice="selectedPOffice"
      :oneConfirmButton="true"
      :indice="-1"
      :key="'detOffice' + -1"
      :detOffice="{
        clientId: this.problem.officeDetails.length + 1,
        office: null,
        noteField: null,
        isNew: true,
        fileList: [],
      }"
      :problem="problem"
      :privilege="privilege"
      :noExecutorWarning="false"
      :structures="problem.execStructures"
      :required_Text="true"
    />
  </a-modal>
</template>

<script>
import OperationCard from "@/components/partials/OperationCard";
export default {
  props: {
    problem: Object,
    privilege: Object,
    visible: Boolean,
    initialOffice:Object,
    selectedPOffice:Object
  },
  components: {
    OperationCard,
  },
  watch: {
    visible: function () {
      this.modalVisible = this.visible;
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.$emit("afterClose");
      }
    },
  },
  data() {
    console.log(this.selectedPOffice,'tetetetette');
    return {
      modalVisible: false,
     
    };
  },
};
</script>

<style>
</style>